export default __webpack_public_path__ + "static/media/outlook.7096e36c.svg";